import { render, staticRenderFns } from "./PageStandard.vue?vue&type=template&id=7301faa2&scoped=true&"
import script from "./PageStandard.vue?vue&type=script&lang=js&"
export * from "./PageStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7301faa2",
  null
  
)

export default component.exports